import React, {useEffect, useState} from 'react';
import {authenticationViewModel} from "../../../viewModels/Authentication.viewModel";
import messages from "res/messages/farsi";
import {useHistory} from "react-router-dom";
import IconTextView, {INPUT_TYPE} from "../../../components/input/IconTextView";
import IconTitleButtonRound from "components/buttons/IconTitleButtonRound";
import IconTitleButton from "components/buttons/IconTitleButton";
import {getButtonHeight, getTextViewHeight, IsF, IsM, IsSM, IsT} from "my-styles/media/media";
import {ALERT_TYPES} from "components/alertMassage/AlertMessage";

import ICEdit from "res/images/edit.png";
import ICVerify from "res/images/verify.png";
import ICArrowBackIosIcon from "res/images/left_arrow.png";
import ICTimer from "res/images/timer.png";
import ICResend from "res/images/resend.png";
import ICFantasticBg1 from "res/images/fantastic_bg_1.png";
import ICFantasticBg2 from "res/images/fantastic_bg_2.png";
import ICVerifyPhone from "res/images/verify_phone.png";

export default function Verify(props) {

    const history = useHistory()
    let telephone = ""
    let invitedCode = ""
    let fromInvitePage = false
    if (props.location.state) {
        telephone = props.location.state.telephone ? props.location.state.telephone : ""
        invitedCode = props.location.state.invitedCode ? props.location.state.invitedCode : ""
        fromInvitePage = props.location.state.fromInvitePage
    }

    let initialMinute = 0
    let initialSecond = 0
    let initialTimerValue = ''

    let getTimerValue = (currentMinute, currentSecond) => {
        return validTimeFormat(currentMinute) + ":" +
            validTimeFormat(currentSecond)
    }
    let validTimeFormat = (time) => {
        if (time.toString().length <= 1) {
            return "0" + time
        }
        return time
    }
    let timerSplited = "01:30".split(":")
    if (timerSplited.length === 2) {
        initialMinute = parseInt(timerSplited[0])
        initialSecond = parseInt(timerSplited[1])
        initialTimerValue = getTimerValue(initialMinute, initialSecond)
    }

    const [verifyCode, setVerifyCode] = useState("")
    const [second, setSecond] = useState(initialSecond)
    const [minute, setMinute] = useState(initialMinute)
    const [timerValue, setTimerValue] = useState(initialTimerValue)
    const [timerIsStoped, setTimerIsStoped] = useState(false)
    const [timerIcon, setTimerIcon] = useState(<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICTimer} className="marginSmall xSmallIcon"/>)

    const timer = () => {
        if (second <= 0 && minute <= 0) {
            setTimerIsStoped(true)
            setTimerValue(messages.resend)
            setTimerIcon(<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICResend} className="marginSmall xSmallIcon"/>)
            return
        }
        let currentSecond = second
        let currentMinute = minute
        if (currentSecond <= 0) {
            if (currentMinute > 0) {
                currentSecond = 59
                if (currentMinute <= 0) {
                    currentSecond = 59
                    currentMinute = minute - 1
                } else {
                    currentMinute = minute - 1
                }
            }
        } else {
            currentSecond = second - 1
        }
        setMinute(currentMinute)
        setSecond(currentSecond)
        setTimerValue(getTimerValue(
            currentMinute,
            currentSecond
        ))
    }

    function requestVerify() {
        if (verifyCode.length > 0) {
            if (telephone) {
                authenticationViewModel.verify(telephone, invitedCode, verifyCode,
                    (data) => {
                        if (data.message) {
                            props.onAlert(data.message, ALERT_TYPES.SUCCESS)
                        }
                        props.onNavigate(history, "/")
                    }, (data) => {
                        if (data !== undefined && data.description !== undefined) {
                            if (data.description === 107) {
                                props.onAlert(messages.verifyNotSuccess)
                            }
                        }
                    }, () => {
                        props.onLoading(true)
                    }, () => {
                        props.onLoading(false)
                    }
                )
            } else {
                props.onNavigate(history, "/login")
            }
        } else {
            props.onAlert(messages.pleaseEnterVerifyCode)
        }
    }

    function requestResend() {
        authenticationViewModel.login(telephone,
            () => {
                setTimerIcon(<img src={ICTimer} alt="" className="marginSmall xSmallIcon"/>)
                setTimerIsStoped(false)
                setMinute(1)
                setSecond(30)
            }, () => {
                props.onAlert(messages.resendError)
            }, () => {
                props.onLoading(true)
            }, () => {
                props.onLoading(false)
            }
        )
    }

    function requestChangeNumber() {
        authenticationViewModel.changeNumber(telephone,
            () => {
                if (fromInvitePage) {
                    props.onNavigate(history, '/invitedByFriend?agentCode=' + invitedCode)
                } else {
                    props.onNavigate(history, '/login')
                }
            }
        )
    }

    useEffect(() => {
        const id = setInterval(timer, 1000)
        return () => clearInterval(id)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [minute, second])

    return (IsSM() || IsM() ?
        <div className="marginSmall" style={{
            backgroundImage: 'url(' + ICFantasticBg2 + ')',
            backgroundSize: "contain",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat"
        }}>
            <table className="fullWidth center" style={{height: "35em"}}>
                <tbody>
                <tr>
                    <td>
                        <center>
                            <div style={{width: "65%"}} className="largeTextBold">
                                {messages.verifyCodeSendedTo}{telephone}{messages.entedIt}
                            </div>
                            <div style={{width: "60%"}} className="marginTopBottomMedium">
                                <IconTextView
                                    type={INPUT_TYPE.NUMBER}
                                    height={getTextViewHeight()}
                                    maxlength="4"
                                    placeholder={messages.verifyCode}
                                    icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICVerify} className="marginSmall xSmallIcon"/>}
                                    onChange={(e) => {
                                        setVerifyCode(e.target.value)
                                    }}
                                    onEnterClick={() => {
                                        requestVerify()
                                    }}/>
                            </div>
                            <div style={{marginTop: "3em", width: "60%"}}>
                                <IconTitleButtonRound
                                    height={getButtonHeight()}
                                    fontSize="mediumTextBold"
                                    onClick={() => {
                                        requestVerify()
                                    }}
                                    icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICArrowBackIosIcon} className="marginSmall xSmallIcon"/>}
                                    title={messages.activate}/>
                            </div>
                            <div style={{width: "60%"}} className="center horizontalScreen marginTopBottomSmall">
                                <div className="halfWidth">
                                    <IconTitleButton
                                        fontSize="largeTextBold"
                                        icon={timerIcon}
                                        title={timerValue}
                                        onClick={() => {
                                            if (timerIsStoped) {
                                                requestResend()
                                            }
                                        }}/>
                                </div>
                                <div className="halfWidth">
                                    <IconTitleButton
                                        fontSize="largeTextBold"
                                        icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICEdit} className="marginSmall xSmallIcon"/>}
                                        title={messages.editTelephone}
                                        onClick={() => {
                                            requestChangeNumber()
                                        }}/>
                                </div>
                            </div>
                        </center>
                    </td>
                </tr>
                </tbody>
            </table>
        </div> :
        IsF() ?
            <div className="marginSmall" style={{
                backgroundImage: 'url(' + ICFantasticBg2 + ')',
                backgroundSize: "contain",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat"
            }}>
                <table className="fullWidth center" style={{height: "35em"}}>
                    <tbody>
                    <tr>
                        <td>
                            <center>
                                <div style={{width: "60%"}} className="largeTextBold">
                                    {messages.verifyCodeSendedTo}{telephone}{messages.entedIt}
                                </div>
                                <div style={{width: "55%"}} className="marginTopBottomMedium">
                                    <IconTextView
                                        type={INPUT_TYPE.NUMBER}
                                        height={getTextViewHeight()}
                                        maxlength="4"
                                        placeholder={messages.verifyCode}
                                        icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICVerify} className="marginSmall xSmallIcon"/>}
                                        onChange={(e) => {
                                            setVerifyCode(e.target.value)
                                        }}
                                        onEnterClick={() => {
                                            requestVerify()
                                        }}/>
                                </div>
                                <div style={{marginTop: "3em", width: "55%"}}>
                                    <IconTitleButtonRound
                                        height={getButtonHeight()}
                                        fontSize="mediumTextBold"
                                        onClick={() => {
                                            requestVerify()
                                        }}
                                        icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICArrowBackIosIcon}
                                                   className="marginSmall xSmallIcon"/>}
                                        title={messages.activate}/>
                                </div>
                                <div style={{width: "55%"}} className="center horizontalScreen marginTopBottomSmall">
                                    <div className="halfWidth">
                                        <IconTitleButton
                                            fontSize="largeTextBold"
                                            icon={timerIcon}
                                            title={timerValue}
                                            onClick={() => {
                                                if (timerIsStoped) {
                                                    requestResend()
                                                }
                                            }}/>
                                    </div>
                                    <div className="halfWidth">
                                        <IconTitleButton
                                            fontSize="largeTextBold"
                                            icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICEdit} className="marginSmall xSmallIcon"/>}
                                            title={messages.editTelephone}
                                            onClick={() => {
                                                requestChangeNumber()
                                            }}/>
                                    </div>
                                </div>
                            </center>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div> :
            IsT() ?
                <div className="marginSmall" style={{
                    backgroundImage: 'url(' + ICFantasticBg2 + ')',
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat"
                }}>
                    <table className="fullWidth center" style={{height: "35em"}}>
                        <tbody>
                        <tr>
                            <td>
                                <center>
                                    <div style={{width: "45%"}} className="largeTextBold">
                                        {messages.verifyCodeSendedTo}{telephone}{messages.entedIt}
                                    </div>
                                    <div style={{width: "40%"}} className="marginTopBottomMedium">
                                        <IconTextView
                                            type={INPUT_TYPE.NUMBER}
                                            height={getTextViewHeight()}
                                            maxlength="4"
                                            placeholder={messages.verifyCode}
                                            icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICVerify} className="marginSmall xSmallIcon"/>}
                                            onChange={(e) => {
                                                setVerifyCode(e.target.value)
                                            }}
                                            onEnterClick={() => {
                                                requestVerify()
                                            }}/>
                                    </div>
                                    <div style={{marginTop: "3em", width: "40%"}}>
                                        <IconTitleButtonRound
                                            height={getButtonHeight()}
                                            fontSize="mediumTextBold"
                                            onClick={() => {
                                                requestVerify()
                                            }}
                                            icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICArrowBackIosIcon}
                                                       className="marginSmall xSmallIcon"/>}
                                            title={messages.activate}/>
                                    </div>
                                    <div style={{width: "40%"}}
                                         className="center horizontalScreen marginTopBottomSmall">
                                        <div className="halfWidth">
                                            <IconTitleButton
                                                fontSize="largeTextBold"
                                                icon={timerIcon}
                                                title={timerValue}
                                                onClick={() => {
                                                    if (timerIsStoped) {
                                                        requestResend()
                                                    }
                                                }}/>
                                        </div>
                                        <div className="halfWidth">
                                            <IconTitleButton
                                                fontSize="largeTextBold"
                                                icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICEdit} className="marginSmall xSmallIcon"/>}
                                                title={messages.editTelephone}
                                                onClick={() => {
                                                    requestChangeNumber()
                                                }}/>
                                        </div>
                                    </div>
                                </center>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div> :
                <div className="horizontalFullScreen">
                    <div className="formContainer">
                        <table className="background full" style={{backgroundImage: 'url(' + ICFantasticBg2 + ')'}}>
                            <tbody>
                            <tr>
                                <td>
                                    <center>
                                        <div className="halfWidth largeTextBold">
                                            {messages.verifyCodeSendedTo}{telephone}{messages.entedIt}
                                        </div>
                                        <div className="halfWidth marginTopBottomMedium">
                                            <IconTextView
                                                type={INPUT_TYPE.NUMBER}
                                                height={getTextViewHeight()}
                                                maxlength="4"
                                                placeholder={messages.verifyCode}
                                                icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICVerify} className="marginSmall xSmallIcon"/>}
                                                onChange={(e) => {
                                                    setVerifyCode(e.target.value)
                                                }}
                                                onEnterClick={() => {
                                                    requestVerify()
                                                }}/>
                                        </div>
                                        <div className="halfWidth" style={{marginTop: "3em"}}>
                                            <IconTitleButtonRound
                                                height={getButtonHeight()}
                                                fontSize="mediumTextBold"
                                                onClick={() => {
                                                    requestVerify()
                                                }}
                                                icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICArrowBackIosIcon}
                                                           className="marginSmall xSmallIcon"/>}
                                                title={messages.activate}/>
                                        </div>
                                        <div className="center halfWidth horizontalScreen marginTopBottomSmall">
                                            <div className="halfWidth">
                                                <IconTitleButton
                                                    fontSize="largeTextBold"
                                                    icon={timerIcon}
                                                    title={timerValue}
                                                    onClick={() => {
                                                        if (timerIsStoped) {
                                                            requestResend()
                                                        }
                                                    }}/>
                                            </div>
                                            <div className="halfWidth">
                                                <IconTitleButton
                                                    fontSize="largeTextBold"
                                                    icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICEdit}
                                                               className="marginSmall xSmallIcon"/>}
                                                    title={messages.editTelephone}
                                                    onClick={() => {
                                                        requestChangeNumber()
                                                    }}/>
                                            </div>
                                        </div>
                                    </center>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="imageContainer">
                        <img className="leftSideBg" src={ICFantasticBg1} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>
                        <img className="leftSideIcon" src={ICVerifyPhone} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>
                    </div>
                </div>)

}